import React, { FC, useState } from "react";
import { Container, Stack } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Flyover from "../Common/Flyover/Flyover";
import SideNavigationMenu from "./SideNavigationMenu";
import { NavigationConfig } from "./types/navigationConfigType";

interface SideNavigationProp {
  navConfigList: NavigationConfig[];
}

const SideNavigation: FC<SideNavigationProp> = (props) => {
  const { navConfigList } = props;
  const [showFlyOver, setShowFlyOver] = useState<boolean>(false);
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end"
      }}
    >
      <Stack
        onClick={() => {
          setShowFlyOver(!showFlyOver);
        }}
      >
        <MenuIcon />
      </Stack>
      <Flyover
        isOpen={showFlyOver}
        closeMenu={() => {
          setShowFlyOver(!showFlyOver);
        }}
      >
        <Container>
          <SideNavigationMenu
            closeMenu={() => {
              setShowFlyOver(!showFlyOver);
            }}
            navigationConfigList={navConfigList}
          />
        </Container>
      </Flyover>
    </Container>
  );
};

export default SideNavigation;
